export const classNames = (...classNames: (string | false | null | undefined)[]) => {
    return classNames.filter(Boolean).join(" ");
};
